(()=>{
  if(customElements.get('ks-progress-option'))return;
  customElements.define('ks-progress-option',class extends HTMLElement{
    static get observedAttributes(){return ['value','maximum'];}
    connectedCallback(){
      this.sync();
      if(this.copyBound)return;
      this.copyBound=true;
      this.addEventListener('click',async event=>{
        const button=event.target.closest('[data-ksp-copy]');
        if(!button||!button.dataset.kspCopy)return;
        const status=this.querySelector('.ksp-copy-status');
        try{await navigator.clipboard.writeText(button.dataset.kspCopy);status.textContent=button.dataset.copied;}
        catch{status.textContent=button.dataset.error;}
      });
    }
    attributeChangedCallback(){if(this.isConnected)this.sync();}
    sync(){
      const total=Number(this.getAttribute('maximum'));
      const raw=Number(this.getAttribute('value'));
      const maximum=Number.isFinite(total)&&total>0?total:1;
      const value=Number.isFinite(raw)?Math.min(maximum,Math.max(0,raw)):0;
      const percent=value/maximum*100;
      this.style.setProperty('--ksp-percent',percent+'%');
      const progress=this.querySelector('progress');
      if(progress){progress.max=maximum;progress.value=value;progress.textContent=Math.floor(percent)+'%';}
      const dial=this.querySelector('[data-ksp-percent]');if(dial)dial.textContent=Math.floor(percent);
    }
    update(state){
      if(state.copyCode!==undefined){
        const button=this.querySelector('[data-ksp-copy]');
        button.dataset.kspCopy=state.copyCode;button.hidden=!state.copyCode;
        button.querySelector('[data-ksp-code]').textContent=state.copyCode;
        button.setAttribute('aria-label',state.copyLabel||state.copyCode);
        button.dataset.copied=state.copiedLabel||'';button.dataset.error=state.copyError||'';
        const link=this.querySelector('.ksp-heading a');if(link)link.hidden=!!state.copyCode;
        this.querySelector('.ksp-copy-status').textContent='';
      }
      if(state.tone!==undefined)this.dataset.tone=state.tone==='light'?'light':'dark';
      if(state.purpose!==undefined)this.dataset.purpose=state.purpose==='drop'?'drop':'offer';
      if(state.maximum!==undefined)this.setAttribute('maximum',state.maximum);
      if(state.value!==undefined)this.setAttribute('value',state.value);
      for(const key of ['heading','detail','note'])if(state[key]!==undefined){
        const target=this.querySelector('[data-ksp-'+key+']');
        if(target){target.textContent=state[key];target.hidden=!state[key];}
      }
      if(state.heading!==undefined)this.querySelector('progress')?.setAttribute('aria-label',state.heading);
      this.sync();
    }
  });
})();
